/** Ključevi putovanja skrivenih s javnih lista i nedostupnih kao /tour/:key. */
const HIDDEN_FROM_PUBLIC = new Set(["alicante-ozujak"]);

export function isTourHiddenFromPublic(tourKey) {
  return HIDDEN_FROM_PUBLIC.has(tourKey);
}

export function filterToursForPublic(tours) {
  if (!tours?.length) return [];
  return tours.filter((t) => !HIDDEN_FROM_PUBLIC.has(t.key));
}
